import React, { memo, useCallback, useEffect, useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import FooterPayment from './FooterPayment/FooterPayment';
import FooterSocial from './FooterSocial/FooterSocial';
import License from './License/License';
import FooterLanguageSwitcher from './FooterLanguageSwitcher';
import FooterMobileApplicationLink from './FooterMobileApplicationLink';
import FooterNavigationMenu from './FooterNavigationMenu';
import FooterUpButton from './FooterUpButton';

const FOOTER_TOP = 64;

const FooterSticky = ({ className }) => {
  const footerRef = useRef(null);

  const updateFooterHeight = useCallback(() => {
    if (footerRef.current) {
      const footer = footerRef.current;
      const footerHeight = footer.offsetHeight;

      const bottomValue = footerHeight - FOOTER_TOP;

      footer.style.bottom = `-${bottomValue}px`;
    }
  }, []);

  useEffect(() => {
    if (!footerRef.current) return;

    const observer = new ResizeObserver(() => {
      updateFooterHeight();
    });

    observer.observe(footerRef.current);

    return () => {
      observer.disconnect();
    };
  }, [updateFooterHeight]);

  return (
    <footer className={cx('footer', 'sticky', className)} ref={footerRef}>
      <div className="container-block">
        <div className="footer__top">
          <div className="footer__top__wrapper">
            <FooterSocial />
            <FooterLanguageSwitcher />
          </div>
          <FooterUpButton />
        </div>
        <div className="footer__grid">
          <div className="footer__info">
            <FooterNavigationMenu />
            <License EGamingIconSize={46} />
          </div>
          <div className="footer__accept">
            <FooterPayment />
            <FooterMobileApplicationLink />
          </div>
        </div>
      </div>
    </footer>
  );
};

FooterSticky.propTypes = {
  className: PropTypes.string,
};

export default memo(FooterSticky);
